export interface TrendItem {
  rank: number;
  title: string;
  category: string;
  heat: string;
  delta: number;
  tag: string;
}

export interface BreakingItem {
  id: number;
  category: string;
  title: string;
  summary: string;
  img: string;
  reads: string;
  comments: string;
  time: string;
  badge?: string;
}

export interface TopicItem {
  id: number;
  name: string;
  desc: string;
  members: string;
  progress: number;
  status: string;
  tag: string;
}

export interface TimelineEvent {
  id: number;
  date: string;
  title: string;
  desc: string;
  type: string;
}

export interface DiscussItem {
  id: number;
  user: string;
  text: string;
  likes: number;
  comments: number;
  time: string;
  tag: string;
  color: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const NAV_ITEMS = [
  { label: "实时热榜", id: "rank" },
  { label: "今日爆点", id: "breaking" },
  { label: "话题追踪", id: "topics" },
  { label: "焦点热议", id: "focus" },
  { label: "时间线", id: "timeline" },
  { label: "吃瓜FAQ", id: "faq" },
  { label: "关于本站", id: "about" },
];

export const TICKER_NEWS = [
  "影坛重磅搭档官宣合体，新片档期引爆讨论",
  "顶流综艺收官夜收视刷新纪录，热议持续升温",
  "科技圈年度旗舰发布会定档，猛料提前流出",
  "体坛焦点大战周末开打，本月大瓜热度飙升",
  "某剧组开机路透疯传，造型话题冲上头条",
  "财经大瓜：重磅并购传闻发酵，业内议论纷纷",
];

export const TREND_LIST: TrendItem[] = [
  { rank: 1, title: "影坛双雄官宣再度合体，新片项目正式启动", category: "影视", heat: "1893万", delta: 1, tag: "爆" },
  { rank: 2, title: "顶流综艺收官夜收视破纪录，名场面全网热议", category: "综艺", heat: "1762万", delta: 1, tag: "爆" },
  { rank: 3, title: "科技旗舰发布会档期提前，供应链猛料曝光", category: "科技", heat: "1540万", delta: 0, tag: "猛" },
  { rank: 4, title: "体坛焦点战本周末开打，双方阵容引发猜想", category: "体育", heat: "1321万", delta: 2, tag: "热" },
  { rank: 5, title: "某剧组开机路透疯传，选角与造型双双冲上热搜", category: "影视", heat: "1187万", delta: -1, tag: "热" },
  { rank: 6, title: "重磅并购传闻发酵，行业分析师纷纷站队", category: "财经", heat: "986万", delta: 3, tag: "猛" },
  { rank: 7, title: "音乐盛典提名名单出炉，入围争议成焦点", category: "娱乐", heat: "874万", delta: 0, tag: "新" },
  { rank: 8, title: "现象级悬疑剧收官反转炸裂，评分再创新高", category: "影视", heat: "769万", delta: -2, tag: "热" },
  { rank: 9, title: "数码博主爆料新机影像升级，网友吵翻了", category: "科技", heat: "652万", delta: 1, tag: "新" },
  { rank: 10, title: "海外音乐节重磅官宣，阵容名单疑遭剧透", category: "娱乐", heat: "528万", delta: 0, tag: "热" },
];

export const BREAK_CATEGORIES = ["全部", "影视", "综艺", "娱乐", "体育", "科技", "财经"];

export const BREAKING_LIST: BreakingItem[] = [
  {
    id: 1,
    category: "影视",
    title: "影坛双雄宣布再度合体：这份猛料让人等太久了",
    summary: "两位久未同框的实力派影人官宣携手新片项目，从剧本选角到制作班底逐条曝光，本月大瓜爆点实锤，全网影迷集体沸腾。",
    img: "https://readdy.ai/api/search-image?query=cinematic%20film%20set%20with%20warm%20studio%20spotlights%2C%20clapperboard%20and%20reel%2C%20editorial%20press%20style%2C%20coral%20red%20and%20gold%20tones%20on%20cream%20backdrop&width=720&height=460&seq=br-film-01&orientation=landscape",
    reads: "128万",
    comments: "4.2万",
    time: "2小时前",
    badge: "爆",
  },
  {
    id: 2,
    category: "综艺",
    title: "顶流综艺收官夜：一晚上四个名场面轮流刷屏",
    summary: "收官夜收视与讨论度双双破纪录，导师金句、选手名场面、催泪告别轮番刷上热搜，成为本月大瓜头条里最有话题性的一晚。",
    img: "https://readdy.ai/api/search-image?query=vibrant%20tv%20variety%20show%20stage%20with%20confetti%20and%20spotlights%2C%20warm%20coral%20and%20gold%20lighting%2C%20editorial%20media%20style%2C%20cream%20background&width=720&height=460&seq=br-show-02&orientation=landscape",
    reads: "97万",
    comments: "3.1万",
    time: "3小时前",
    badge: "爆",
  },
  {
    id: 3,
    category: "科技",
    title: "年度旗舰发布会档期提前，供应链猛料抢跑曝光",
    summary: "多方消息称发布档期较预期大幅提前，核心硬件参数、影像升级与定价策略均被提前剧透，科技圈本月大瓜猛料集中爆发。",
    img: "https://readdy.ai/api/search-image?query=futuristic%20gadget%20product%20on%20minimal%20warm%20clay%20pedestal%2C%20gold%20and%20coral%20accent%20lighting%2C%20editorial%20product%20photography&width=720&height=460&seq=br-tech-03&orientation=landscape",
    reads: "76万",
    comments: "2.4万",
    time: "5小时前",
    badge: "猛",
  },
  {
    id: 4,
    category: "体育",
    title: "体坛焦点战周末开打：首发名单成最大悬念",
    summary: "两支争冠热门本周正面交锋，主帅排兵布阵与核心轮换成为焦点，赛前发布会火药味十足，吃瓜群众已搬好小板凳。",
    img: "https://readdy.ai/api/search-image?query=energetic%20stadium%20arena%20under%20warm%20lights%20with%20crowd%20and%20court%2C%20editorial%20sports%20media%20style%2C%20coral%20and%20gold%20tones&width=720&height=460&seq=br-sport-04&orientation=landscape",
    reads: "63万",
    comments: "1.8万",
    time: "6小时前",
    badge: "热",
  },
  {
    id: 5,
    category: "娱乐",
    title: "音乐盛典提名争议发酵，入围名单成焦点讨论",
    summary: "年度音乐盛典提名名单一经公布，部分大热歌手落选引发广泛争议，奖项公平性成为本月大瓜焦点，乐迷们吵得不可开交。",
    img: "https://readdy.ai/api/search-image?query=glittering%20music%20award%20trophy%20and%20golden%20confetti%20on%20warm%20cream%20background%2C%20editorial%20style%2C%20coral%20and%20gold%20tones&width=720&height=460&seq=br-music-05&orientation=landscape",
    reads: "58万",
    comments: "2.7万",
    time: "8小时前",
    badge: "新",
  },
  {
    id: 6,
    category: "财经",
    title: "重磅并购传闻发酵：业内排队表态，信号耐人寻味",
    summary: "一则潜在并购传闻点燃财经圈，标的估值、交易结构与监管风向被逐一拆解，多方解读让焦点愈发明朗又更显扑朔。",
    img: "https://readdy.ai/api/search-image?query=modern%20finance%20city%20skyline%20with%20warm%20golden%20hour%20light%2C%20editorial%20business%20news%20style%2C%20coral%20and%20gold%20tones%2C%20cream%20sky&width=720&height=460&seq=br-fin-06&orientation=landscape",
    reads: "51万",
    comments: "1.2万",
    time: "9小时前",
    badge: "猛",
  },
  {
    id: 7,
    category: "影视",
    title: "现象级悬疑剧收官反转，结局评分一路走高",
    summary: "收官集用一个反转直接封神，埋了整季的伏笔全部回收，观众纷纷二刷找细节，热议延续至今仍未降温。",
    img: "https://readdy.ai/api/search-image?query=moody%20mystery%20series%20scene%20with%20dramatic%20warm%20side%20lighting%20and%20shadows%2C%20cinematic%20editorial%20style%2C%20coral%20and%20ink%20tones&width=720&height=460&seq=br-drama-07&orientation=landscape",
    reads: "47万",
    comments: "3.5万",
    time: "12小时前",
    badge: "热",
  },
  {
    id: 8,
    category: "科技",
    title: "数码博主集中爆料新机影像：参数之争吵上热搜",
    summary: "多家博主同步释放新一代机型影像样张与规格信息，阵营对垒明显，谁是最终赢家尚无定论，围观热度直线上升。",
    img: "https://readdy.ai/api/search-image?query=sleek%20smartphone%20camera%20module%20macro%20detail%20on%20warm%20clay%20surface%2C%20gold%20accent%20lighting%2C%20editorial%20tech%20photography&width=720&height=460&seq=br-cam-08&orientation=landscape",
    reads: "39万",
    comments: "9800",
    time: "14小时前",
    badge: "新",
  },
  {
    id: 9,
    category: "综艺",
    title: "爆款恋综嘉宾联动名场面：同框瞬间弹幕炸裂",
    summary: "跨节目联动让两大顶流阵容意外同框，互动细节被逐帧解读，cp 讨论与新瓜线索一并引爆，成为本期人气最高的一幕。",
    img: "https://readdy.ai/api/search-image?query=romantic%20reality%20dating%20show%20set%20with%20warm%20string%20lights%20and%20pastel%20coral%20decor%2C%20editorial%20tv%20media%20style&width=720&height=460&seq=br-rom-09&orientation=landscape",
    reads: "35万",
    comments: "2.1万",
    time: "16小时前",
    badge: "热",
  },
  {
    id: 10,
    category: "娱乐",
    title: "海外音乐节重磅官宣，阵容名单疑似提前剧透",
    summary: "海外年度音乐节官宣落地，随即有网友声称已流出首轮阵容，主办方尚未正面回应，乐迷的期待值被瞬间拉满。",
    img: "https://readdy.ai/api/search-image?query=open%20air%20music%20festival%20crowd%20at%20sunset%20with%20stage%20lights%2C%20warm%20coral%20and%20gold%20tones%2C%20editorial%20event%20photography&width=720&height=460&seq=br-fest-10&orientation=landscape",
    reads: "29万",
    comments: "8600",
    time: "18小时前",
    badge: "新",
  },
  {
    id: 11,
    category: "体育",
    title: "明星球员续约进入倒计时，去向成本月最大悬念",
    summary: "核心球员续约谈判被曝进入关键阶段，多支球队虎视眈眈，去向问题连续多日霸榜，球迷与路人都在蹲一个结果。",
    img: "https://readdy.ai/api/search-image?query=dramatic%20sports%20contract%20signing%20table%20with%20jersey%20and%20warm%20arena%20lights%20behind%2C%20editorial%20sports%20media%20style&width=720&height=460&seq=br-star-11&orientation=landscape",
    reads: "24万",
    comments: "7100",
    time: "20小时前",
    badge: "热",
  },
  {
    id: 12,
    category: "影视",
    title: "年度大女主剧官宣演员，粉丝与路人各执一词",
    summary: "年度古装大剧女主角正式官宣，选角话题两极分化，原作粉与原班人马粉争论不休，为该剧提前攒足了热度。",
    img: "https://readdy.ai/api/search-image?query=elegant%20period%20drama%20costume%20draped%20fabric%20and%20hanfu%20accessories%20on%20warm%20cream%20background%2C%20editorial%20cinema%20style%2C%20coral%20and%20gold&width=720&height=460&seq=br-astro-12&orientation=landscape",
    reads: "21万",
    comments: "5.4万",
    time: "昨天",
    badge: "热",
  },
];

export const TOPIC_LIST: TopicItem[] = [
  {
    id: 1,
    name: "#影坛双雄合体新片#",
    desc: "从立项传闻到正式官宣，全流程跟进两人合作项目的最新动态与幕后花絮。",
    members: "86.4万",
    progress: 82,
    status: "官宣后持续发酵",
    tag: "影视",
  },
  {
    id: 2,
    name: "#顶流综艺收官名场面#",
    desc: "定格收官夜的每一个高光瞬间，梳理导师金句、选手舞台与全网热议名场面。",
    members: "74.2万",
    progress: 95,
    status: "热度见顶回落",
    tag: "综艺",
  },
  {
    id: 3,
    name: "#旗舰发布会猛料追踪#",
    desc: "紧追发布会档期、核心参数与影像升级线索，官方发声前持续核实爆料源。",
    members: "51.8万",
    progress: 46,
    status: "爆料集中阶段",
    tag: "科技",
  },
  {
    id: 4,
    name: "#体坛焦点战前瞻#",
    desc: "两队状态、排兵布阵与伤病情况跟踪，赛前发布会第一时间总结焦点信息。",
    members: "43.6万",
    progress: 60,
    status: "赛前预热升温",
    tag: "体育",
  },
  {
    id: 5,
    name: "#年度盛典提名争议#",
    desc: "汇总提名名单、落选热门与主办方回应，持续记录争议各方的真实声音。",
    members: "32.1万",
    progress: 38,
    status: "争议发酵中",
    tag: "娱乐",
  },
  {
    id: 6,
    name: "#并购传闻全程解读#",
    desc: "从传闻出现到多方表态，逐日拆解标的估值、交易结构与监管风向关键节点。",
    members: "27.9万",
    progress: 55,
    status: "待官方回应",
    tag: "财经",
  },
];

export const TIMELINE_EVENTS: TimelineEvent[] = [
  { id: 1, date: "09-01", title: "传闻初现：影坛双雄疑再合作", desc: "社交平台出现两人同框洽谈的照片，合作传闻首次浮出水面。", type: "线索" },
  { id: 2, date: "09-03", title: "片方半遮半掩回应", desc: "知情人士透露项目已进入前期筹备，制作班底名单部分流出。", type: "跟进" },
  { id: 3, date: "09-06", title: "综艺收官夜名场面刷屏", desc: "顶流综艺收官收视破纪录，四个名场面轮番登上热搜。", type: "爆点" },
  { id: 4, date: "09-09", title: "发布会档期提前确认", desc: "科技旗舰发布会官宣提前，供应链参数猛料集中流出。", type: "实锤" },
  { id: 5, date: "09-11", title: "体坛焦点战正式开打", desc: "两支争冠球队正面交锋，首发名单悬念揭晓，讨论度飙至顶点。", type: "爆点" },
  { id: 6, date: "09-14", title: "盛典提名争议持续", desc: "多方联署呼吁公开评选流程，主办方宣布将回应舆论关切。", type: "跟进" },
];

export const DISCUSS_LIST: DiscussItem[] = [
  {
    id: 1,
    user: "吃瓜打工人",
    text: "影坛双雄居然真合体了，这个本月大瓜我从月初就蹲着，今晚必须把进度补完，感觉明年贺岁档又要提前预定爆款了。",
    likes: 3260,
    comments: 182,
    time: "2小时前",
    tag: "影视",
    color: "bg-primary-500",
  },
  {
    id: 2,
    user: "追更不熬夜",
    text: "收官夜那场告别我直接看哭，导师那句金句后劲太大。全网都在二刷找名场面，我只能说这个瓜吃得很值。",
    likes: 2481,
    comments: 146,
    time: "4小时前",
    tag: "综艺",
    color: "bg-accent-500",
  },
  {
    id: 3,
    user: "参数党小柯",
    text: "这波旗舰爆料信息量爆炸，影像参数如果属实，那真的很难顶。先码住等发布会实锤，别到时候又是一场空欢喜。",
    likes: 1893,
    comments: 98,
    time: "7小时前",
    tag: "科技",
    color: "bg-secondary-500",
  },
  {
    id: 4,
    user: "半夜看球选手",
    text: "周末焦点战票都抢好了！首发悬念这波拉满，就想看强强对话，输赢不重要，过程够精彩就行。",
    likes: 1542,
    comments: 77,
    time: "9小时前",
    tag: "体育",
    color: "bg-primary-500",
  },
];

export const FAQ_LIST: FaqItem[] = [
  {
    q: "「本月大瓜」更新频率是怎样的？",
    a: "本站围绕本月大瓜爆点与猛料实时滚动更新，热门焦点出现后通常在数分钟内跟进梳理；综合榜单每小时刷新一次热度排序，爆点与话题追踪板块则随信息核实进度分批更新。",
  },
  {
    q: "什么是本月大瓜爆点与猛料？",
    a: "爆点指当月讨论度、传播速度都极高的热门事件；猛料则侧重尚未完全实锤、仍处于跟进发酵阶段的关键线索。本站会对两者标注「爆 / 猛 / 热 / 新」标签，帮助你看清事件所处阶段。",
  },
  {
    q: "劲爆头条与热门焦点的来源可靠吗？",
    a: "本站所有内容均以可查证的公开信息与当事人 / 官方回应为准进行整理，来源会尽量标注。对仍处于传播中的信息，我们会明确提示其待核实状态，避免把未经证实的说法当作定论。",
  },
  {
    q: "如何参与某个热点的讨论？",
    a: "在「焦点热议」板块可直接对感兴趣的观点点赞或评论，热度会实时更新；你也可以通过页面内站内搜索按关键词定位到具体爆点与话题进行围观。",
  },
  {
    q: "在哪里能看到完整的时间线？",
    a: "前往页面中部的「吃瓜时间线」板块即可按日期回看本月大瓜的关键节点，从线索出现、跟进发酵到实锤确认一目了然，方便你快速补课不迷路。",
  },
  {
    q: "发现站内信息有误该如何反馈？",
    a: "请通过页脚或「关于本站」中的联系邮箱反馈，说明具体条目与信息来源，我们会尽快核实并更正。欢迎大家一起把瓜吃得更准。",
  },
];